import React, { useMemo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

function GridDeclineCell(props) {
  const {
    item,
    rowClass,
  } = props;

  const space = useMemo(() => item.declineSpace, [item.declineSpace]);
  const bar = useMemo(() => item.declineBar, [item.declineBar]);

  return (
    <div className={classNames('conversion-goals-graph-decline', rowClass)}>
      <div className="decline-box">
        <div className="graph-space" style={{ flex: space }} />
        <div className="graph-bar" style={{ flex: bar }} />
      </div>
    </div>
  );
}

GridDeclineCell.defaultProps = {
};
GridDeclineCell.propTypes = {
  item: PropTypes.shape({
    declineSpace: PropTypes.number,
    declineBar: PropTypes.number,
  }).isRequired,
  rowClass: PropTypes.string.isRequired,
};

export default GridDeclineCell;
